import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AllowedAttributeValueService } from './api/allowedAttributeValue.service';
import { ApplicationService } from './api/application.service';
import { AttributeValueListService } from './api/attributeValueList.service';
import { AvailabilityDayService } from './api/availabilityDay.service';
import { BusinessObjectDataService } from './api/businessObjectData.service';
import { BusinessObjectDataAttributeService } from './api/businessObjectDataAttribute.service';
import { BusinessObjectDataNotificationRegistrationService } from './api/businessObjectDataNotificationRegistration.service';
import { BusinessObjectDataStatusService } from './api/businessObjectDataStatus.service';
import { BusinessObjectDataStorageFileService } from './api/businessObjectDataStorageFile.service';
import { BusinessObjectDataStorageUnitService } from './api/businessObjectDataStorageUnit.service';
import { BusinessObjectDataStorageUnitStatusService } from './api/businessObjectDataStorageUnitStatus.service';
import { BusinessObjectDefinitionService } from './api/businessObjectDefinition.service';
import { BusinessObjectDefinitionColumnService } from './api/businessObjectDefinitionColumn.service';
import { BusinessObjectDefinitionDescriptionSuggestionService } from './api/businessObjectDefinitionDescriptionSuggestion.service';
import { BusinessObjectDefinitionSubjectMatterExpertService } from './api/businessObjectDefinitionSubjectMatterExpert.service';
import { BusinessObjectDefinitionTagService } from './api/businessObjectDefinitionTag.service';
import { BusinessObjectFormatService } from './api/businessObjectFormat.service';
import { BusinessObjectFormatExternalInterfaceDescriptiveInformationService } from './api/businessObjectFormatExternalInterfaceDescriptiveInformation.service';
import { BusinessObjectFormatToExternalInterfaceMappingService } from './api/businessObjectFormatToExternalInterfaceMapping.service';
import { ConfigurationEntryService } from './api/configurationEntry.service';
import { CurrentUserService } from './api/currentUser.service';
import { CustomDDLService } from './api/customDDL.service';
import { DataProviderService } from './api/dataProvider.service';
import { DepartmentService } from './api/department.service';
import { EMRService } from './api/eMR.service';
import { EMRClusterDefinitionService } from './api/eMRClusterDefinition.service';
import { ExpectedPartitionValueService } from './api/expectedPartitionValue.service';
import { ExternalInterfaceService } from './api/externalInterface.service';
import { FileTypeService } from './api/fileType.service';
import { GlobalAttributeDefinitionService } from './api/globalAttributeDefinition.service';
import { IndexSearchService } from './api/indexSearch.service';
import { JobService } from './api/job.service';
import { JobDefinitionService } from './api/jobDefinition.service';
import { NamespaceService } from './api/namespace.service';
import { NamespaceIAMRoleAuthorizationService } from './api/namespaceIAMRoleAuthorization.service';
import { NotificationRegistrationStatusService } from './api/notificationRegistrationStatus.service';
import { PartitionKeyGroupService } from './api/partitionKeyGroup.service';
import { PublishingFrequencyService } from './api/publishingFrequency.service';
import { RecordGroupService } from './api/recordGroup.service';
import { RelationalTableRegistrationService } from './api/relationalTableRegistration.service';
import { SearchIndexService } from './api/searchIndex.service';
import { SearchIndexActivationService } from './api/searchIndexActivation.service';
import { SecurityFunctionService } from './api/securityFunction.service';
import { SecurityRoleService } from './api/securityRole.service';
import { SecurityRoleToFunctionMappingService } from './api/securityRoleToFunctionMapping.service';
import { StorageService } from './api/storage.service';
import { StoragePlatformService } from './api/storagePlatform.service';
import { StoragePolicyService } from './api/storagePolicy.service';
import { StorageUnitService } from './api/storageUnit.service';
import { StorageUnitNotificationRegistrationService } from './api/storageUnitNotificationRegistration.service';
import { SubjectMatterExpertService } from './api/subjectMatterExpert.service';
import { SystemJobService } from './api/systemJob.service';
import { TagService } from './api/tag.service';
import { TagTypeService } from './api/tagType.service';
import { UploadAndDownloadService } from './api/uploadAndDownload.service';
import { UserNamespaceAuthorizationService } from './api/userNamespaceAuthorization.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AllowedAttributeValueService,
    ApplicationService,
    AttributeValueListService,
    AvailabilityDayService,
    BusinessObjectDataService,
    BusinessObjectDataAttributeService,
    BusinessObjectDataNotificationRegistrationService,
    BusinessObjectDataStatusService,
    BusinessObjectDataStorageFileService,
    BusinessObjectDataStorageUnitService,
    BusinessObjectDataStorageUnitStatusService,
    BusinessObjectDefinitionService,
    BusinessObjectDefinitionColumnService,
    BusinessObjectDefinitionDescriptionSuggestionService,
    BusinessObjectDefinitionSubjectMatterExpertService,
    BusinessObjectDefinitionTagService,
    BusinessObjectFormatService,
    BusinessObjectFormatExternalInterfaceDescriptiveInformationService,
    BusinessObjectFormatToExternalInterfaceMappingService,
    ConfigurationEntryService,
    CurrentUserService,
    CustomDDLService,
    DataProviderService,
    DepartmentService,
    EMRService,
    EMRClusterDefinitionService,
    ExpectedPartitionValueService,
    ExternalInterfaceService,
    FileTypeService,
    GlobalAttributeDefinitionService,
    IndexSearchService,
    JobService,
    JobDefinitionService,
    NamespaceService,
    NamespaceIAMRoleAuthorizationService,
    NotificationRegistrationStatusService,
    PartitionKeyGroupService,
    PublishingFrequencyService,
    RecordGroupService,
    RelationalTableRegistrationService,
    SearchIndexService,
    SearchIndexActivationService,
    SecurityFunctionService,
    SecurityRoleService,
    SecurityRoleToFunctionMappingService,
    StorageService,
    StoragePlatformService,
    StoragePolicyService,
    StorageUnitService,
    StorageUnitNotificationRegistrationService,
    SubjectMatterExpertService,
    SystemJobService,
    TagService,
    TagTypeService,
    UploadAndDownloadService,
    UserNamespaceAuthorizationService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
